<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ct"><a id="page_ii"></a><a id="page_iii"></a>Cast of Characters</h2>
<p class="hang">E<span class="small">RNESTINE</span>—hates men and vents her spite in a way that’s sure to lead to trouble</p>
<p class="hang">F<span class="small">REDDY</span> N<span class="small">IXON</span>—who pays dearly for his sordid past</p>
<p class="hang">M<span class="small">RS</span>. L<span class="small">ACOSTE</span>—matriarchal goof-ball lover who indulges herself when her family is out of the way</p>
<p class="hang">M<span class="small">R</span>. P<span class="small">ENNYFEATHER</span>—an ardent, if absent-minded, devotee of Milton and mysteries</p>
<p class="hang">R<span class="small">AE</span> C<span class="small">ARADYNE</span>—worries about her cousin, Ernestine’s, escapades</p>
<p class="hang">M<span class="small">RS</span>. M<span class="small">AUFFIT</span>—whose cooking comforts Mr. Pennyfeather but fails to fatten him</p>
<p class="hang">P<span class="small">ROFESSOR</span> T<span class="small">ODT</span>—cultivates beans and looks for the psychological causes of plant and human behavior</p>
<p class="hang">M<span class="small">R</span>. S<span class="small">TEPHEN</span> D<span class="small">UNNE</span>—red-bearded beach-combing artist, devoted to drink and driftwood, and his nieces, Ernestine and Rae</p>
<p class="hang">C<span class="small">APTAIN</span> O<span class="small">LNEY</span>—doesn’t say much, but there’s no wool over his eyes</p>
<p class="hang">M<span class="small">RS</span>. L<span class="small">ELAND</span>—wife of a college professor, distracted by dogs and bawling babies</p>
<p class="hang">L<span class="small">ORETTA</span> C<span class="small">ULLENS</span>—ex-pupil of Mr. Pennyfeather’s, is surprised to find herself mixed up in murder</p>
<p class="hang">M<span class="small">R</span>. J<span class="small">AROLD</span> A<span class="small">CTON</span>—one-time schoolteacher who used his position to lead youth astray</p>
<p class="hang">M<span class="small">RS</span>. C<span class="small">ULLENS</span>—Loretta’s mother, clubwoman walking a tight rope</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Characters.vue?28e1bddc